import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';
import { localStoragePlugin } from './plugins';
import auth from '@/app/auth/auth.store';
import account from '@/app/account/account.store';
import user from '@/app/user/user.store';
import useradministration from '@/app/administration/useradministration.store';
import country from '@/app/country/country.store';
import offer from '@/app/offer/offer.store';
import offerevaluation from '@/app/offerevaluation/offerevaluation.store';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        packageVersion: JSON.stringify(require('../../package.json').version),
    },
    getters: {
        appVersion: (state) => state.packageVersion,
    },
    modules: {
        common,
        auth,
        account,
        user,
        useradministration,
        country,
        offer,
        offerevaluation,
    },
    plugins: [localStoragePlugin],
});
